import React from 'react';
import { getBuilderConfigURL } from '../common/utils/builder-config-url-util';
import { getCookie } from '../features/home/app_util';

let token = getCookie('token');
if (!token) {
  token = '';
}

export const typeIcons = {
  Page: <i className="wb webconnect-file-alt" />,
  Snippet: <i className="wb webconnect-layout-text-window-reverse" />,
  Modal: <i className="wb webconnect-files-alt" />,
  'Custom Segment': <i className="wb webconnect-breadcrumb" />,
  'Sub Page': <i className="wb webconnect-file-earmark-richtext" />,
  'PDF Template': <i className="wb webconnect-layout-text-sidebar-reverse" />,
  'Page Layout': <i className="wb webconnect-breadcrumb" />,
  Event: <i className="wb webconnect-diagram-3-fill" />,
  Collection: <i className="wb webconnect-database" />,
  'External API': <i className="wb webconnect-rocket" />,
  'Email Template': <i className="wb webconnect-envelope-fill" />,
  'SMS Template': <i className="wb webconnect-chat-left-text" />,
  'Tooltip Template': <i className="wb webconnect-info-circle-fill" />,
  'Agreement Template': <i className="wb webconnect-edit" />,
  'Typesense Search Template': <i className="wb webconnect-search" />,
  'Socket IO Template': <i className="wb webconnect-lightning-charge-fill" />,
  'Custom Component': <i className="wb webconnect-easel" />,
  'Custom Data Mapping': <i className="wb webconnect-bezier2" />,
  'Background Task': <i className="wb webconnect-alarm" />,
  'Custom Function': <i className="wb webconnect-edit" />,
};

const redirectUrl = getBuilderConfigURL();

export const createPagesURL = (version, projectId) => {
  return {
    Page: `/editor/${version}/v/${projectId}/loader?open-modal=create-page`,
    Snippet: `/editor/${version}/v/${projectId}/loader`,
    Modal: `/editor/${version}/v/${projectId}/loader`,
    'Custom Segment': `/editor/${version}/v/${projectId}/loader`,
    'Sub Page': `/editor/${version}/v/${projectId}/loader`,
    'PDF Template': `/editor/${version}/v/${projectId}/loader`,
    'Page Layout': `/editor/${version}/v/${projectId}/loader`,
    Event: `${redirectUrl}events/${version}/v/${projectId}/create?token=${token}`,
    Collection: `${redirectUrl}collections/${version}/v/${projectId}/create?token=${token}`,
    'External API': `${redirectUrl}externalapi/${version}/v/${projectId}/create?token=${token}`,
    'Email Template': `${redirectUrl}template/${version}/v/${projectId}/mails/create?token=${token}`,
    'SMS Template': `${redirectUrl}template/${version}/v/${projectId}/messages/create?token=${token}`,
    'Tooltip Template': `${redirectUrl}template/${version}/v/${projectId}/tooltips/create?token=${token}`,
    'Agreement Template': `${redirectUrl}template/${version}/v/${projectId}/agreements/create?token=${token}`,
    'Typesense Search Template': `${redirectUrl}template/${version}/v/${projectId}/typesenseSearch/create?token=${token}`,
    'Socket IO Template': `${redirectUrl}template/${version}/v/${projectId}/socketIo/create?token=${token}`,
    'Custom Component': `${redirectUrl}custom-component/${version}/v/${projectId}/customComponent/create?token=${token}`,
    'Custom Data Mapping': `${redirectUrl}custom-component/${version}/v/${projectId}/customDataMapping/create?token=${token}`,
    'Background Task': `${redirectUrl}schedule/${version}/v/${projectId}/create?token=${token}`,
    'Custom Function': `${redirectUrl}custom-component/${version}/v/${projectId}/customFunction/create?token=${token}`,
  };
};

export const appSettingsURL = (version, projectId) => {
  return {
    Collections: `${redirectUrl}collections/${version}/v/${projectId}?token=${token}`,
    Events: `${redirectUrl}events/${version}/v/${projectId}?token=${token}`,
    Plugins: `${redirectUrl}plugin/${version}/v/${projectId}?token=${token}`,
    'App Setting': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/app-config?token=${token}`,
    'Developer API': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/devKey?token=${token}`,
    'Custom CSS': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/custom-css?token=${token}`,
    'Custom JS': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/custom-js?token=${token}`,
    'PWA Config': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/pwa-config?token=${token}`,
    'Data Encryption': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/encryption-section?token=${token}`,
    Template: `${redirectUrl}template/${version}/v/${projectId}?token=${token}`,
    'Data Source': `${redirectUrl}data-connector/${version}/v/${projectId}?token=${token}`,
    Localization: `${redirectUrl}app-setting/${version}/v/${projectId}/setting/localization-section?token=${token}`,
    'System Logs': `${redirectUrl}logger/${version}/v/${projectId}?token=${token}`,
    'Background Task': `${redirectUrl}schedule/${version}/v/${projectId}?token=${token}`,
    'Delete Permission': `${redirectUrl}permission/${version}/v/${projectId}?token=${token}`,
    'Code Export': `${redirectUrl}deployment-setting/${version}/v/${projectId}/code-export?token=${token}`,
    'App Constant': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/appConstant?token=${token}`,
    'Page Setting': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/pageSetting?token=${token}`,
    'Loading Icon': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/loadingIcon?token=${token}`,
    'Robots.txt': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/robots?token=${token}`,
    'Sitemap.xml': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/sitemapXml?token=${token}`,
    Environment: `${redirectUrl}app-setting/${version}/v/${projectId}/setting/environment?token=${token}`,
    'Project Version': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/version?token=${token}`,
    'Notification Setting': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/notificationSetting?token=${token}`,
    Resources: `${redirectUrl}app-setting/${version}/v/${projectId}/setting/resources?token=${token}`,
    Profiler: `${redirectUrl}app-setting/${version}/v/${projectId}/setting/profiler-section?token=${token}`,
    'System Activity': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/system-activity?token=${token}`,
    'Publish Activity': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/publish-activity?token=${token}`,
    'Page Snapshot': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/pageSnapshot?token=${token}`,
    'Snippet Snapshot': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/snippetShapshot?token=${token}`,
    'Collection Snapshot': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/collectionSnapshot?token=${token}`,
    'Custom Fonts': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/customFonts?token=${token}`,
    'Global Theme': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/globalTheme?token=${token}`,
    'Typography & Colours': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/typographyColours?token=${token}`,
    'Custom Component': `${redirectUrl}custom-component/${version}/v/${projectId}/customComponent?token=${token}`,
    'Custom Data Mapping': `${redirectUrl}custom-component/${version}/v/${projectId}/customDataMapping?token=${token}`,
    'External APIs': `${redirectUrl}externalapi/${version}/v/${projectId}?token=${token}`,
    'AI Model Configuration': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/aiModelConfig-section?token=${token}`,
    'Loader Screen': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/loader-screen?token=${token}`,
    'Custom Function': `${redirectUrl}custom-component/${version}/v/${projectId}/customFunction?token=${token}`,
    'Import From Figma': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/figmaConfig-section?token=${token}`,
    'PHI Audit': `${redirectUrl}app-setting/${version}/v/${projectId}/setting/phi-audit?token=${token}`,
  };
};

export const originURLMapping = (type) => {
  const domainName = window.location.hostname;
  let redirectUrl = `https://${domainName}`;
  const surfaceTypes = [
    'Page',
    'Snippet',
    'Modal',
    'Custom Segment',
    'Sub Page',
    'PDF Template',
    'Page Layout',
  ];
  if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
    redirectUrl = surfaceTypes.includes(type)
      ? `http://${domainName}:6075`
      : `http://${domainName}:9075`;
  } else if (process.env.REACT_APP_ENVIRONMENT === 'STAGING') {
    if (!surfaceTypes.includes(type)) {
      const updatedDomain = domainName.replace('builder.webkonnect.xyz', 'builderc.webkonnect.xyz');
      redirectUrl = `https://${updatedDomain}`;
    }
  } else {
    if (!surfaceTypes.includes(type)) {
      const updatedDomain = domainName.replace('builder.mydrapcode.com', 'builderc.mydrapcode.com');
      redirectUrl = `https://${updatedDomain}`;
    }
  }
  return redirectUrl;
};

export const types = [
  'Agreement Template',
  'Background Task',
  'Collection',
  'Custom Component',
  'Custom Function',
  'Custom Data Mapping',
  'Custom Segment',
  'Email Template',
  'Event',
  'External API',
  'Modal',
  'Page',
  'Page Layout',
  'PDF Template',
  'SMS Template',
  'Snippet',
  'Sub Page',
  'Tooltip Template',
  'Typesense Search Template',
  'Socket IO Template',
];
